import axios from "axios";
import { GOSTORE_UTILITY_TOOLS_SERVICE_ENDPOINT } from "./config";

const axiosInstance = axios.create({
  baseURL: GOSTORE_UTILITY_TOOLS_SERVICE_ENDPOINT,
  withCredentials: true,
});

export default axiosInstance;
